module.exports = __webpack_public_path__ + "static/media/termostaty_dlya_m.9e737efb.pdf";